"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var Message = function Message() {
  return _react.default.createElement("svg", {
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, _react.default.createElement("title", null, "Message"), _react.default.createElement("g", {
    id: "\uD83D\uDE80-Components",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    id: "drawer_component",
    transform: "translate(-349.000000, -124.000000)",
    fill: "#B5BACE",
    fillRule: "nonzero"
  }, _react.default.createElement("g", {
    id: "Group-7",
    transform: "translate(78.000000, 97.000000)"
  }, _react.default.createElement("g", {
    id: "Group",
    transform: "translate(30.000000, 20.000000)"
  }, _react.default.createElement("g", {
    id: "Group-10",
    transform: "translate(233.000000, 0.000000)"
  }, _react.default.createElement("path", {
    d: "M15.89225,7 C11.55275,7 8.0345,10.52575 8.0345,14.875 C8.0345,16.5385 8.55275,18.079 9.43175,19.35025 L8,25 L15.563,22.7335 C15.6725,22.738 15.78125,22.75 15.89225,22.75 C20.23175,22.75 23.75,19.22425 23.75,14.875 C23.75,10.52575 20.23175,7 15.89225,7 M15.89225,9.25 C18.9845,9.25 21.5,11.773 21.5,14.875 C21.5,17.97625 18.9845,20.5 15.90875,20.5 L15.842,20.49625 C15.7805,20.49175 15.719,20.488 15.65675,20.485 L15.27875,20.46925 L14.9165,20.578 L11.156,21.70525 L11.612,19.903 L11.86325,18.91225 L11.28275,18.0715 C10.6295,17.12725 10.2845,16.02175 10.2845,14.875 C10.2845,11.773 12.80075,9.25 15.89225,9.25",
    id: "Message"
  })))))));
};

var _default = Message;
exports.default = _default;